export class Instance<T> {
    #instance: T | undefined;

    get instance(): T {
        if (this.#instance === undefined) {
            throw new TypeError('The instance has not been configured.');
        }

        return this.#instance;
    }

    setInstance(instance: T): void {
        this.#instance = instance;
    }
}
